import React, { useCallback } from 'react';
import { connectPagination } from 'react-instantsearch-dom';

import Pagination from '../../../Pagination';

const AlgoliaPagination = ({
  currentRefinement,
  nbPages,
  refine,
  onPageChange,
  ...props
}) => {
  const _refine = useCallback(
    value => {
      refine(value);
      onPageChange();
    },
    [refine, onPageChange],
  );
  const pages = [...Array(nbPages).keys()].map(page => page + 1);
  return (
    <Pagination
      pages={pages}
      value={currentRefinement}
      onChange={_refine}
      {...props}
    />
  );
};

const ConnectedAlgoliaPagination = connectPagination(AlgoliaPagination);

export default ConnectedAlgoliaPagination;
